import { Box, Flex, Heading } from '@chakra-ui/react'
import CloseReasonCard from '../components/CloseReasonCard.jsx'

const CloseReasonManagementPage = () => {
  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="300px" p="5">
      <Flex p={5} mb="3">
        <Heading> Closing Reason Management </Heading>
      </Flex>
      <Flex direction="column" gap="3">
        <CloseReasonCard type="offer" shouldShowSubReasons={true} />
        <CloseReasonCard type="maintenance" shouldShowSubReasons={false} />
      </Flex>
    </Box>
  )
}

export default CloseReasonManagementPage
